<template>
  <div class="overview_page">
    <div class="detail_tabs">
      <div v-for="tab in detailTabs" :key="tab.key" class="detail_tab" :class="{ active: activeDetail === tab.key }"
        @click="activeDetail = tab.key">
        {{ tab.label }}
      </div>
    </div>

    <div class="time_tabs">
      <div v-for="tab in timeTabs" :key="tab" class="time_tab" :class="{ active: activeTime === tab }"
        @click="timeChange(tab)">
        {{ tab }}
      </div>
    </div>
    <van-calendar v-model="showDatePicker" :min-date="minDate" :max-date="maxDate" :default-date="defaultDate"
      type="range" color="#12c8c9" :allow-same-day="true" @confirm="onConfirmDate" />

    <div v-if="activeDetail === 'clock'" class="clock_content">
      <div class="filter_box">
        <button v-for="item in clockFilters" :key="item.clocktype" class="clock_filter" :class="{ active: item.clocktype ===filterClockType }"
          type="button" @click="filterClock(item.clocktype)">
          {{ item.clocktype }}: {{ item.count }}
        </button>
      </div>

      <div class="clock_list">
        <div v-for="(item, index) in shownClockList" :key="index" class="clock_item">
          <div class="clock_top">
            <div class="project_info">
              <div class="clock_badge">{{ item.clocktype.slice(0, 1) }}</div>
              <div class="project_name">{{ item.project }}</div>
              <div class="checkout_tag" v-if="item.billid&&item.billid!==null" >已结账</div>
               <div class="checkout_tag" v-else >未结账</div>
            </div>
            <div class="clock_time">{{ item.starttime }}</div>
          </div>

          <div class="clock_bottom">
            <div class="money_info">
              <span class="muted">基本提成</span>
              <span class="money">￥{{ item.basepersume || 0 }}</span>
              <span class="muted allowance">阶梯提成</span>
              <span class="money">￥{{ item.steppersume || 0 }}</span>
            </div>
            <div class="clock_count">钟数: {{ item.numbercount || 0 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="commission_content">
      <div class="commission_top">
        <div class="commission_title">{{ activeTime }}提成</div>
        <div class="amount_circle">￥{{ queryValue(allTotal.totalpersume) }}</div>
        <div class="summary">
          <span>基本提成</span>
          <strong>￥{{ queryValue(allTotal.basepersume) }}</strong>
          <span class="step_label">阶梯提成</span>
          <strong>￥{{ queryValue(allTotal.steppersume) }}</strong>
        </div>
      </div>

      <div v-for="section in commissionSections" :key="section.title" class="commission_section">
        <div class="section_title">{{ section.title }}</div>
        <div class="section_row">
          <div v-for="item in section.items" :key="item.label" class="section_item">
            <div class="section_num">{{ item.value }}</div>
            <div class="section_label">{{ item.label }}</div>
          </div>
          <!-- <div class="arrow">›</div> -->
        </div>
      </div>
    </div>

    <myFooter></myFooter>
  </div>
</template>

<script>
import { getClockstatistics, getPersumestatistics } from '@/api/Jishi';
import { handleSessionStorage } from '@/utils';
import myFooter from "@/components/myFooter";
export default {
  name: "JiShiCommissionAndClockDetail",
  components: { myFooter },
  data() {
    return {
      detailTabs: [
        { label: "做钟详情", key: "clock" },
        { label: "提成详情", key: "commission" }
      ],
      activeDetail: "clock",
      timeTabs: ["今天", "昨天", "本月", "上月", "自定义"],
      activeTime: "今天",
      clockFilters: [],
      clockList: [],
      getVpnId: "",
      shownClockList: [],
      allClockList: [],
      showDatePicker: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      defaultDate: [],
      allTotal: {
        totalpersume: 0,
        basepersume: 0,
        steppersume: 0
      },
      commissionSections: [],
      filterClockType:'全部'
    };
  },
  created() {
    const preStoreInfo = localStorage.getItem("store");
    if (preStoreInfo) {
      this.getVpnId = JSON.parse(preStoreInfo).vpnId;
    }
    this.timeChange("今天");
  },
  methods: {

    filterClock(type){
     this.filterClockType = type
       if(type=="全部"){
          this.timeChange(this.activeTime)
       }else {
         this.shownClockList =[]
         const result = this.allClockList.filter(item=>item.clocktype===type)
        this.shownClockList.push(...result)
       }
    },

    async timeChange(tab) {
      this.activeTime = tab;
      console.log("时间改变事件 ====" + handleSessionStorage.get("jsCode"));
      if (!handleSessionStorage.get("jsCode")) {
        return;
      }
      if (tab === '自定义') {
        this.defaultDate = [
          this.startTime ? new Date(this.startTime.replace(/-/g, '/')) : new Date(),
          this.endTime ? new Date(this.endTime.replace(/-/g, '/')) : new Date()
        ];
        this.showDatePicker = true;
        return;
      }
      const timeRange = this.getTimeRangeByTab(tab);
      this.startTime = timeRange.startTime;
      this.endTime = timeRange.endTime;
      this.queryPersumestatistics();
    },
    queryPersumestatistics() {
      const originParams = {
        Pager: {
          PageIndex: 0,
          PageSize: 1000,
        },
        JiShiCode: handleSessionStorage.get('jsCode'), // 技师或服务员编号
        StartTime: this.startTime,
        EndTime: this.endTime,
        ClockType: '',
        VpnId: this.getVpnId
      }
      getPersumestatistics(originParams).then(res => {
        this.shownClockList = res.lst_persume_clock || [];
        this.allClockList = res.lst_persume_clock || [];
        this.allTotal = res.persume_total || {}
        this.querycommissionSections(res)
        this.queryclockFilters()
      }).finally(onfinally => {
        console.log("timeChangetimeChange ==== ")
      })
    },

    onConfirmDate(date) {
      const [start, end] = date;
      this.showDatePicker = false;
      this.startTime = this.formatDate(start);
      this.endTime = this.formatDate(end);
      this.queryPersumestatistics();
    },

    queryclockFilters() {
      this.clockFilters =[]
      const waitTypeList = []
      this.shownClockList.forEach(item => {
        if (!waitTypeList.includes(item.clocktype)) {
          waitTypeList.push(item.clocktype)
        }
      })

      let totalCount = 0
      waitTypeList.forEach(key => {
        const clocktype = {
          clocktype: key,
          count: 0
        }
        this.shownClockList.forEach(item => {
           if(key==item.clocktype){
            clocktype.count = clocktype.count+(item.numbercount||0)
             totalCount =totalCount +(item.numbercount||0)
           }
        
        })
        this.clockFilters.push(clocktype)
      })
       this.clockFilters.unshift({
        clocktype: "全部",
        count: totalCount
      })
    },

    querycommissionSections(res) {
      const persume_clock_total = res.persume_clock_total || {}
      const persume_project_total = res.persume_project_total || {}
      const persume_goods_total = res.persume_goods_total || {}
      const persume_card_total = res.persume_card_total || {}
      this.commissionSections = [
        {
          title: "做钟提成",
          items: [
            { value: this.queryValue(persume_clock_total.count), label: "上钟单数" },
            { value: "￥" + this.queryValue(persume_clock_total.steppersume), label: "阶梯提成" },
            { value: "￥" + this.queryValue(persume_clock_total.basepersume), label: "基本提成" }
          ]
        },
        {
          title: "项目推销提成",
          items: [
            { value: "￥" + this.queryValue(persume_project_total.amount), label: "推销金额" },
            { value: this.queryValue(persume_project_total.count), label: "推销单数" },
            { value: "￥" + this.queryValue(persume_project_total.totalpersume), label: "推销提成" }
          ]
        },
        {
          title: "商品推销提成",
          items: [
            { value: "￥" + this.queryValue(persume_goods_total.amount), label: "推销金额" },
            { value: this.queryValue(persume_goods_total.count), label: "推销单数" },
            { value: "￥" + this.queryValue(persume_goods_total.totalpersume), label: "推销提成" }
          ]
        },
        {
          title: "售卡充值提成",
          items: [
            { value: this.queryValue(persume_card_total.count), label: "售卡单数" },
            { value: "￥" + this.queryValue(persume_card_total.steppersume), label: "阶梯提成" },
            { value: "￥" + this.queryValue(persume_card_total.basepersume), label: "基本提成" }
          ]
        }
      ];
      // console.log("querycommissionSections ====" +JSON.stringify(this.commissionSections))
    },

    queryValue(vaule) {
      if (vaule === undefined) {
        return 0
      } else if (vaule === null) {
        return 0
      } else {
        return vaule
      }
    },

    queryCurrentDay() {
      return this.formatDate(new Date());
    },
    formatDate(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      return `${y}-${m}-${d}`;
    },
    getTimeRangeByTab(tab) {
      const date = new Date();
      const today = this.formatDate(date);
      const tomorrow = this.formatDate(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));

      if (tab === '今天') {
        return {
          startTime: today,
          endTime: tomorrow
        };
      }

      if (tab === '昨天') {
        const yesterdayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1);
        const yesterday = this.formatDate(yesterdayDate);
        return {
          startTime: yesterday,
          endTime: tomorrow
        };
      }

      if (tab === '本月') {
        const monthStart = this.formatDate(new Date(date.getFullYear(), date.getMonth(), 1));
        return {
          startTime: monthStart,
          endTime: tomorrow
        };
      }

      if (tab === '上月') {
        const lastMonthStartDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
        const lastMonthEndDate = new Date(date.getFullYear(), date.getMonth(), 0);
        return {
          startTime: this.formatDate(lastMonthStartDate),
          endTime: this.formatDate(lastMonthEndDate)
        };
      }
    }

  }
};
</script>

<style scoped lang="scss">
.overview_page {
  min-height: 100vh;
  background: #ffffff;
  color: #333333;
  font-family: PingFangSC-Regular, PingFang SC;
  overflow-x: hidden;
}

.detail_tabs {
  height: 78px;
  display: flex;
  background: #ffffff;
  border-bottom: 1px solid #e8e8e8;
}

.detail_tab {
  position: relative;
  flex: 1;
  height: 78px;
  color: #666666;
  font-size: 24px;
  line-height: 78px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;

  &.active {
    color: #12c8c9;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 100%;
      height: 4px;
      background: #12c8c9;
    }
  }
}

.time_tabs {
  height: 70px;
  display: flex;
  background: #ffffff;
  border-bottom: 18px solid #f3f3f3;
  box-sizing: content-box;
}

.time_tab {
  position: relative;
  flex: 1;
  height: 70px;
  color: #333333;
  font-size: 24px;
  line-height: 70px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;

  &:not(:last-child) {
    border-right: 1px solid #f2f2f2;
  }

  &.active {
    color: #12c8c9;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background: #12c8c9;
    }
  }
}

.clock_content {
  padding: 26px 24px 0;
  box-sizing: border-box;
}

.filter_box {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 18px;
}

.clock_filter {
  min-width: 152px;
  height: 78px;
  margin: 0 10px 12px 0;
  padding: 0 28px;
  border: 2px solid #12c8c9;
  border-radius: 10px;
  background: #ffffff;
  color: #12c8c9;
  font-size: 26px;
  line-height: 74px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  text-align: center;
  box-sizing: border-box;

  &.active {
    background: #12c8c9;
    color: #ffffff;
  }
}

.clock_item {
  height: 118px;
  padding: 18px 0 16px;
  border-bottom: 1px solid #e8e8e8;
  box-sizing: border-box;
}

.clock_top,
.clock_bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.project_info {
  min-width: 0;
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 12px;
}

.clock_badge {
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  margin-right: 16px;
  border-radius: 50%;
  background: #1e86ff;
  color: #ffffff;
  font-size: 22px;
  line-height: 40px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.project_name {
  min-width: 0;
  max-width: 250px;
  color: #333333;
  font-size: 22px;
  line-height: 34px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.checkout_tag {
  flex: 0 0 auto;
  height: 30px;
  margin-left: 10px;
  padding: 0 6px;
  border-radius: 3px;
  background: #12c8c9;
  color: #ffffff;
  font-size: 20px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.clock_time {
  flex: 0 0 auto;
  color: #8d8d8d;
  font-size: 18px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  white-space: nowrap;
  text-align: right;
}

.clock_bottom {
  margin-top: 12px;
}

.money_info {
  min-width: 0;
  flex: 1;
  white-space: nowrap;
}

.muted,
.clock_count {
  color: #8a8a8a;
  font-size: 22px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
}

.money {
  margin-left: 8px;
  color: #333333;
  font-size: 20px;
  line-height: 30px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.allowance {
  margin-left: 16px;
}

.clock_count {
  flex: 0 0 auto;
  margin-left: 10px;
  font-size: 18px;
}

.commission_content {
  padding: 0 18px;
  box-sizing: border-box;
}

.commission_top {
  padding: 30px 0 16px;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
}

.commission_title {
  margin-bottom: 38px;
  color: #666666;
  font-size: 24px;
  line-height: 32px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.amount_circle {
  width: 168px;
  height: 168px;
  margin: 0 auto 34px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 34px rgba(221, 221, 221, 0.62);
  color: #12c8c9;
  font-size: 28px;
  line-height: 168px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.summary {
  color: #333333;
  font-size: 22px;
  line-height: 34px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;

  strong {
    margin-left: 8px;
    color: #12c8c9;
    font-size: 26px;
  }

  .step_label {
    margin-left: 28px;
  }
}

.commission_section {
  border-bottom: 1px solid #e8e8e8;
}

.section_title {
  padding-left: 10px;
  padding-top: 18px;
  color: #333333;
  font-size: 22px;
  line-height: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.section_row {
  height: 90px;
  display: flex;
  align-items: center;
  text-align: center;
}

.section_item {
  flex: 1;
  min-width: 0;
}

.section_num {
  margin-bottom: 8px;
  color: #333333;
  font-size: 30px;
  line-height: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 700;
}

.section_label {
  color: #999999;
  font-size: 22px;
  line-height: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
}

.arrow {
  flex: 0 0 50px;
  color: #666666;
  font-size: 44px;
  line-height: 1;
  font-family: Arial, Helvetica, sans-serif;
}

::v-deep .logo-bottom,
::v-deep .g-logo-bottom {
  margin-top: 86px;
  opacity: 0.55;
}

@media (max-width: 360px) {
  .project_name {
    max-width: 210px;
  }

  .summary .step_label {
    margin-left: 12px;
  }

  .section_num {
    font-size: 26px;
  }
}
</style>
